import React from 'react'
import MainLayout from '../../layout/MainLayout'
import Reports from '../../components/analytics/reports/Reports'

const ReportsPage = () => {
  return (
    <MainLayout>
        <Reports />
    </MainLayout>
  )
}

export default ReportsPage